// Actions

/**
 * Get TEAM
 */
export const GET_TEAM = "GET_TEAM";
export const GET_TEAM_SUCCESS = "GET_TEAM_SUCCESS";
export const GET_TEAM_FAILED = "GET_TEAM_FAILED";

/**
 * Received TEAM
 */
export const RECEIVED_TEAM = "RECEIVED_TEAM";

/**
 * Invite TEAM
 */
export const INVITE_TEAM = "INVITE_TEAM";
export const INVITE_TEAM_SUCCESS = "INVITE_TEAM_SUCCESS";
export const INVITE_TEAM_FAILED = "INVITE_TEAM_FAILED";

/**
 * Delete TEAM
 */
export const DELETE_TEAM = "DELETE_TEAM";
export const DELETE_TEAM_SUCCESS = "DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_FAILED = "DELETE_TEAM_FAILED";

/**
 * Reset TEAM
 */
export const RESET_INVITE_STATUS = "RESET_INVITE_STATUS";
export const RESET_DELETE_STATUS = "RESET_DELETE_STATUS";
export const RESET_TEAM_ERROR = "RESET_TEAM_ERROR";
